import React from "react";
import "./spinner.css";

const Spinner = ({txt}) => {
    return (
        <div className="col">
            <p className="text-center mt-5 text-muted">{txt}</p>
            <div className="spinner">
                <div className="bounce1" />
                <div className="bounce2" />
                <div className="bounce3" />
            </div>
        </div>
    );
};

export default Spinner;
